import { ShippingWithReturnIntakeSummaryDto } from '../../../models';
import SummaryListSkeleton from './SummaryListSkeleton';
import SummaryItemCard from './SummaryItemCard';
import EmptyState from './EmptyState';
import { Fade } from '@mui/material';

interface SummaryListProps {
  shippings: ShippingWithReturnIntakeSummaryDto[];
  emptyMessage: string;
  isLoading?: boolean;
}

const SummaryList = ({ shippings, emptyMessage, isLoading }: SummaryListProps) => {
  if (isLoading) {
    return <SummaryListSkeleton />;
  }

  if (shippings.length === 0) {
    return <EmptyState message={emptyMessage} />;
  }

  return (
    <div className='flex flex-col gap-4'>
      {shippings.map((shipping, index) => (
        <Fade 
          in={true} 
          key={shipping.id}
          timeout={600}
          style={{ transitionDelay: `${index * 50}ms` }}
        >
          <div>
            <SummaryItemCard 
              shipping={shipping} 
              index={index} 
            />
          </div>
        </Fade>
      ))}
    </div>
  );
};

export default SummaryList;
